"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import dynamic from "next/dynamic";
import { useSearchParams } from "next/navigation";
import { KeyNames } from "@packages/lib/utlils/filters/filterJson";
import { extractUrlAndSessionValues } from "@packages/lib/utlils/filters/result-filters";
import LocationCheckBox from "@packages/shared-components/sr-page/SrFilter/locationCheckBox";
import { generatePathName } from "@packages/lib/utlils/filters/result-filters";
import { useFilterContext } from "@packages/lib/utlils/use-context/filter-context";
const ParentRegionSvg = dynamic(() => import("./parent-region-svg"), {
  ssr: false,
});
type Region = {
  regionId: number;
  parentRegionId: number;
  regionTextKey: string;
};
const Regions = ({
  item,
  regionListData,
  formUrl,
  appendSearchParams,
}: any) => {
  const keyName = KeyNames();
  const searchparams = useSearchParams();
  const {
    selectedLocation,
    setSelectedLocation,
    slug,
    locationState,
    setLocationState,
  } = useFilterContext();
  const [isRegionSelected, setIsRegionSelected] = useState<any>(false);

  useEffect(() => {
    const appliedLocationsArray = extractUrlAndSessionValues(
      searchparams,
      "",
      "",
      false,
      false
    )?.location?.split("+");
    setIsRegionSelected(appliedLocationsArray?.includes(item?.regionTextKey));
  }, [searchparams, item?.regionTextKey, keyName?.location]);

  const getSelectedRegion = (regionTextKey: string) =>
    regionListData?.find(
      (region: any) => region?.regionTextKey === regionTextKey
    );

  const doesItcontainChild = (selectedRegion: any) =>
    regionListData?.some(
      (region: any) => region?.parentRegionId === selectedRegion?.regionId
    );

  const getParentRegion: any = (selectedRegion: any) => {
    return regionListData?.find(
      (region: any) => region?.regionId == selectedRegion?.parentRegionId
    );
  };

  function toggleRegionInLists(
    regionTextKey: string,
    parentList: string[],
    childList: string[],
    regionList: Region[]
  ) {
    const updatedParent = [...parentList];
    const updatedChild = [...childList];

    const findRegionByTextKey = (key: string) =>
      regionList?.find((region) => region?.regionTextKey === key);

    const getChildrenRegionTextKeys = (parentRegion: Region) => {
      return (
        regionList
          ?.filter(
            (region) => region?.parentRegionId === parentRegion?.regionId
          )
          ?.map((region) => region?.regionTextKey) || []
      );
    };

    const selectedRegion = findRegionByTextKey(regionTextKey);
    if (!selectedRegion) return { parent: updatedParent, child: updatedChild };

    const isParent = selectedRegion?.parentRegionId === 1;

    if (isParent) {
      const isParentSelected = updatedParent.includes(regionTextKey);

      if (isParentSelected) {
        // Remove parent and its children
        const children = getChildrenRegionTextKeys(selectedRegion);
        const filteredChild = updatedChild.filter(
          (childKey) => !children.includes(childKey)
        );
        setLocationState((prev: any) => ({
          ...prev,
          appliedParentRegion: updatedParent.filter(
            (key) => key !== regionTextKey
          ),
          appliedChildRegion: filteredChild,
        }));
        return {
          parent: updatedParent.filter((key) => key !== regionTextKey),
          child: filteredChild,
        };
      } else {
        // Add parent and its children
        const children = getChildrenRegionTextKeys(selectedRegion);
        setLocationState((prev: any) => ({
          ...prev,
          appliedParentRegion: [...updatedParent, regionTextKey],
          appliedChildRegion: Array.from(
            new Set([...updatedChild, ...children])
          ),
        }));
        return {
          parent: [...updatedParent, regionTextKey],
          child: Array.from(new Set([...updatedChild, ...children])),
        };
      }
    } else {
      const isChildSelected = updatedChild?.includes(regionTextKey);
      if (isChildSelected) {
        setLocationState((prev: any) => ({
          ...prev,
          appliedParentRegion: updatedParent,
          appliedChildRegion: updatedChild.filter(
            (key) => key !== regionTextKey
          ),
        }));
        return {
          parent: updatedParent,
          child: updatedChild.filter((key) => key !== regionTextKey),
        };
      } else {
        setLocationState((prev: any) => ({
          ...prev,
          appliedParentRegion: updatedParent,
          appliedChildRegion: [...updatedChild, regionTextKey],
        }));
        return {
          parent: updatedParent,
          child: [...updatedChild, regionTextKey],
        };
      }
    }
  }

  const locationclicked = (regionTextKey: string) => {
    toggleRegionInLists(
      regionTextKey,
      locationState?.appliedParentRegion,
      locationState?.appliedChildRegion,
      regionListData
    );

    let appliedRegions: any =
      extractUrlAndSessionValues(
        new URLSearchParams(window.location.search),
        "",
        ""
      )?.location?.split("+") || [];
    const selectedRegion = getSelectedRegion(regionTextKey);
    const parentRegion = getParentRegion(selectedRegion);

    if (appliedRegions?.includes(regionTextKey)) {
      appliedRegions = appliedRegions?.filter(
        (region: any) => region !== regionTextKey
      );
    } else {
      if (doesItcontainChild(selectedRegion)) {
        const children = regionListData
          ?.filter(
            (region: any) => region?.parentRegionId === selectedRegion?.regionId
          )
          ?.map((region: any) => region.regionTextKey);
        appliedRegions = appliedRegions?.filter(
          (item: any) => !children?.includes(item)
        );
        appliedRegions.push(regionTextKey);
      } else {
        const getSiblingRegion = regionListData
          ?.filter(
            (region: any) =>
              region?.parentRegionId === selectedRegion?.parentRegionId &&
              region?.parentRegionId != 1 &&
              region?.regionTextKey !== selectedRegion?.regionTextKey
          )
          ?.map((region: any) => region.regionTextKey);
        const doesItParentRegionApplied = appliedRegions?.includes(
          parentRegion?.regionTextKey
        );

        if (doesItParentRegionApplied) {
          appliedRegions = appliedRegions?.filter(
            (item: any) => item !== parentRegion?.regionTextKey
          );
          appliedRegions.push(...getSiblingRegion);
        } else {
          const isSiblingRegionApplied =
            Array.isArray(getSiblingRegion) &&
            getSiblingRegion.length > 0 &&
            getSiblingRegion.every((item: any) =>
              appliedRegions?.includes(item)
            );
          if (isSiblingRegionApplied) {
            appliedRegions = appliedRegions?.filter(
              (item: any) => !getSiblingRegion?.includes(item)
            );
            appliedRegions?.push(parentRegion?.regionTextKey);
          } else {
            appliedRegions?.push(regionTextKey);
          }
        }
      }
    }
    if (appliedRegions?.length > 0) {
      setSelectedLocation("region");
    }
    appendSearchParams(keyName?.location, appliedRegions?.join("+"));
  };

  return (
    <>
      <div className="form_check relative m-[0_0_12px]">
        <div className="flex items-start gap-[8px]">
          <div className="checkbox_card">
            <Link
              className="hidden"
              id={keyName?.location + item?.regionTextKey}
              href={{
                pathname: generatePathName(slug, keyName?.location),
                query: formUrl(keyName?.location, item?.regionTextKey),
              }}
            >
              {item?.regionName}
            </Link>
            <input
              disabled={selectedLocation === "city"}
              checked={isRegionSelected || false}
              onChange={() => {
                setIsRegionSelected(!isRegionSelected);
                locationclicked(item?.regionTextKey);
              }}
              type="checkbox"
              className="form-checkbox hidden"
              id={item?.regionName}
              name={item?.regionName}
            />

            <label
              htmlFor={item?.regionName}
              className="flex justify-center items-center w-[16px] h-[16px] rounded-[3px] border-2 border-grey-600 my-[2px] group-checked:bg-primary-400 cursor-pointer"
            >
              <ParentRegionSvg />
            </label>
          </div>
          <label
            htmlFor={item?.regionName}
            className="check-label small font-normal text-grey300 w-[calc(100%_-_28px)]"
          >
            {item?.regionName}
          </label>
        </div>
      </div>
      <ul>
        <li className="grid grid-cols-1 sm:grid-cols-2">
          {regionListData
            ?.map((regionlist: any) => {
              if (regionlist?.parentRegionId == item?.regionId) {
                return regionlist;
              }
            })
            ?.filter(Boolean)
            ?.map((childItem: any, index: any) => (
              <LocationCheckBox
                key={index + 1}
                childItem={childItem}
                regionListData={regionListData}
                formUrl={formUrl}
                locationclicked={locationclicked}
              />
            ))}
        </li>
      </ul>
    </>
  );
};
export default Regions;
